{
  "hangarsPresenter": {
    "title": "Hangars – {{fboName}}",
    "stats": {
      "totalHangars": "Hangars gesamt",
      "totalAircraft": "Flugzeuge in Hangars gesamt"
    },
    "columns": {
      "hangarName": "Hangarname",
      "aircraft": "Flugzeug",
      "utilization": "Auslastung",
      "estValue": "Gesch. Wert",
      "estTowTime": "Schleppzeit",
      "lastStacked": "Zul. gestapelt",
      "actions": "Aktionen"
    },
    "tooltips": {
      "aircraftCount": "# Flugzeuge im Hangar / # gewünschte Flugzeuge",
      "utilization": {
        "title": "Auslastung",
        "stacked": "<strong>Gestapelt</strong> zeigt die aktuelle Auslastung, die 100% überschreiten kann, wenn Flugzeuge im Negativraum anderer Flugzeug-Stellflächen geparkt sind.",
        "fullLoad": "<strong>Bei voller Mieterbelegung</strong> zeigt, wie hoch die Auslastung wäre, wenn alle diesem Hangar zugewiesenen Flugzeuge gleichzeitig am Boden wären.",
        "gauge": "Die Anzeige zeigt eine Basismarkierung bei 100 % – blau darunter, grün darüber.",
        "adjust": "Passe die Berechnung unter Einstellungen → Konfiguration an"
      },
      "estValue": "Geschätzter Wert des Hangars pro Nacht basierend auf vollständig im Hangar befindlichen Flugzeugen",
      "estValueBreakdown": "Base: ${{base}} | Trans: ${{transient}}",
      "estTowTime": "Geschätzte Zeit für die Hangar-Positionierung"
    },
    "emptyState": {
      "title": "Noch keine Hangars",
      "description": "Erstelle deinen ersten Hangar, um Flugzeuglagerung und Stacking-Operationen zu verwalten."
    }
  },
  "utilizationDisplay": {
    "stacked": "gestapelt",
    "atFullTenantLoad": "bei voller Auslastung"
  },
  "multiHangarSelector": {
    "label": "Hangars auswählen",
    "selectAll": "Alle auswählen",
    "goButton": "Los",
    "noHangars": {
      "primary": "Keine Hangars verfügbar",
      "secondary": "Erstelle zuerst einen Hangar, um diese Funktion zu nutzen"
    }
  },
  "hangarRow": {
    "aircraftCount": "{{inside}} / {{total}} Flugzeuge",
    "lastStacked": {
      "tooltip": "Datum der letzten Stack-Operation",
      "never": "Nie"
    },
    "buttons": {
      "currentHangar": "Aktueller Hangar",
      "hangarSchedule": "Hangarplan",
      "editTenants": "Mandanten bearb."
    }
  }
}
